import React from "react";

function Project(props) {
  return (
    <div className="content relative overflow-hidden">
      <img src={props.screenshot} alt="" className=" rounded-xl"/>
      <div className="textContent bg-white/40 backdrop-blur-sm text-black p-1 md:p-2 lg:p-4 h-full rounded-xl">
        <h4 className="text-lg md:text-2xl lg:text-4xl m-2 lg:m-3">{props.title}</h4>
        <div className="flex gap-5 m-2 lg:m-3">
          {
            props.tech.map((t,index) => {
              return(
                <p className="text-sm md:text-md lg:text-xl bg-black/90 rounded-lg p-1 text-white">{t}</p>
              )
            })
          }
        </div>
        <p className="text-md md:text-lg lg:text-2xl ml-2 md:m-2 lg:m-3">{props.desc}</p>
        <a className="text-md md:text-lg lg:text-2xl ml-2 md:m-2 lg:m-3" href={props.link}>Live</a>
      </div>
    </div>
  );
}

export default Project;
